
import React, { useEffect, useState } from "react";
import { Button, Col, Container, OffcanvasBody, OffcanvasHeader, Row } from "reactstrap";
import { errorHandler } from "utils/Api";
import DefaultOffCanvas from "../DefaultOffCanvas";
import form from 'formConfigs/addPackageAdviceNotice';
import { savePackage } from "api/PackagesApi";
import DynamicForm from "components/DynamicForm";
import { showAlert } from "utils/Alert";
import { poBoxLabelGenerator } from "utils/Form";
import FileUploadInput from "components/DynamicForm/components/FileUploadInput";
import styles from "./style.module.scss";
import { makeFormUneditable } from "components/DynamicForm/utils";
import { reportWarehousePrealert } from "api/WarehousePrealertApi";
import { trackEvent } from "utils/Analytics";
import { ANALYTIC_EVENT_ACTIONS, ANALYTIC_EVENT_CATEGORIES } from "utils/Constants";
import { getAddressOptions } from "utils/Utils";

const PackageAdviseNoticeOffCanvas = props => {
    const { btnColor = "primary", className, adviseData, poBox, onSave } = props;
    const [isOpen, setOpen] = useState(false);
    const [packageAdviseData, setPackageAdviseData] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [isEditable, setEditable] = useState(true);
    const [adviceFiles, setAdviceFiles] = useState([]);
    const isAdviceEdit = adviseData?.id;

    useEffect(() => {
        if (isAdviceEdit) {
            setInitialData();
        } else {
            setPackageAdviseData({});
        }
    }, [isAdviceEdit, adviseData]);

    const setInitialData = () => {
        if (adviseData.id) {
            setOpen(true);
            const adviseDataFiles = (adviseData.boxAssets && adviseData.boxAssets.items) || []
            setAdviceFiles(adviseDataFiles);

            if (adviseData?.boxCost?.id || adviseData.cargoMovement) {
                setEditable(false);
            }
        }
        setPackageAdviseData(adviseData);
    }


    const toogleOffCanvas = (newState) => {
        setOpen(newState);
        if (newState === false) {
            onCanvasClosed();
        } else {
            trackEvent(ANALYTIC_EVENT_CATEGORIES.USER, ANALYTIC_EVENT_ACTIONS.OPEN_MODAL, "Crear/Actualizar Prealerta de Paquete")
        }
    }

    const onCanvasClosed = () => {
        setPackageAdviseData({});
        setEditable(true);
        setOpen(false);
        setAdviceFiles([]);
    }

    const getOffcanvasLabel = () => {
        if (!isEditable) {
            return "Ver Paquete"
        } else if (isAdviceEdit) {
            return `Modificar Prealerta`;
        }
        return "Crear Prealerta";
    }

    const savePackageAdviseNotice = (formData) => {
        // De momento la factur es opcional
        // if (adviceFiles.length == 0) {
        //     showAlert("danger", "Por favor agregar al menos 1 documento para su prealerta")
        //     return;
        // }

        const packageData = {
            client: poBoxLabelGenerator(poBox),
            poBoxBoxesId: poBox.id,
            origin: "US",
            puerto_carga: "Miami",
            destino: "CR",
            ...formData
        }
        setIsLoading(true);
        savePackage(packageData, adviceFiles).then(async (r) => {
            showAlert("success", "La prealerta fue creada exitosamente");
            setOpen(false);
            reportWarehousePrealert(r);
            if (onSave) {
                onSave(r);
            }
        }).catch(e => {
            showAlert("danger", "No fue posible crear la prealerta")
            errorHandler(e, "Crear o modificar pre alerta");
        }).finally(e => setIsLoading(false));

    }

    const onUpdateFiles = (files) => {
        setAdviceFiles(files);
    }

    const getFormConfig = () => {
        const deliveryType = form.sections.flatMap(s => s.fields).flat().find(f => f.name === "delivery_type")
        if (deliveryType) {
            const addresses = poBox?.addresses?.items || [];
            const addressList = getAddressOptions(addresses);
            deliveryType.options = addressList
        }
        if (isEditable) {
            return form;
        } else {
            return makeFormUneditable(form);
        }
    }

    return (
        <>
            <Button
                color={btnColor}
                className={className}
                onClick={() => toogleOffCanvas(!isOpen)}
            >
                {props.children}
            </Button>
            <DefaultOffCanvas
                direction="end"
                isOpen={isOpen}
                onClosed={onCanvasClosed}
                toggle={() => toogleOffCanvas(!isOpen)}
            >
                <OffcanvasHeader className={styles.offCanvasHeader} toggle={onCanvasClosed}>
                    {getOffcanvasLabel()}
                </OffcanvasHeader>
                <OffcanvasBody className={styles.offCanvasBody}>
                    <Container>
                        <DynamicForm
                            id="addPackageAdviseNotice"
                            externalFormState={packageAdviseData}
                            formConfig={getFormConfig()}
                            onSubmit={savePackageAdviseNotice}
                            isLoading={isLoading}>
                            <Container>
                                <Row>
                                    <Col>
                                        <FileUploadInput
                                            disabled={!isEditable}
                                            files={adviceFiles}
                                            allowMultiple={true}
                                            onUpdateFiles={onUpdateFiles}
                                            name="files"
                                            labelIdle="Arrastre los documentos del paquete en este area"
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        {isEditable ?
                                            (
                                                <Button
                                                    className="float-end"
                                                    type="submit"
                                                    color="success">
                                                    Guardar
                                                </Button>)
                                            :
                                            (
                                                <Button
                                                    className="float-end"
                                                    onClick={onCanvasClosed}
                                                    type="button"
                                                    color="danger">
                                                    Cerrar
                                                </Button>
                                            )
                                        }
                                    </Col>
                                </Row>
                            </Container>
                        </DynamicForm>
                    </Container>
                </OffcanvasBody>
            </DefaultOffCanvas>
        </>
    );
}
export default PackageAdviseNoticeOffCanvas;
